import styled from "styled-components";


export const StyledSpacingDiv = styled.div`
  @media (max-width: 600px) {
    margin-bottom: 100px !important;
  }
`;